/** Angular Imports. */
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Dates } from 'app/core/utils/dates';

/** Custom Services. */
import { SettingsService } from 'app/settings/settings.service';
import { VaultTransactionsService } from '../vault-transactions.service';
import { MatDialog } from '@angular/material/dialog';
import { TellerGlobalServiceService } from 'app/shared/teller-data/teller-global-service.service';
import { DialogHelper } from 'app/core/utils/dialog-helper';
import { ReceiptServiceService } from 'app/shared/receipt-dialog/receipt-service.service';
import { Observable } from 'rxjs';
import { OTPRequestData } from 'app/model/tillotp';

/**
 * Allocate Cash component.
 */
@Component({
  selector: 'mifosx-allocate-cash',
  templateUrl: './allocate-cash.component.html',
  styleUrls: ['./allocate-cash.component.scss']
})
export class AllocateCashComponent implements OnInit {

  /** Minimum Date allowed. */
  minDate = new Date(2000, 0, 1);
  /** Maximum Date allowed. */
  maxDate = new Date();
  /** Cashier data. */
  cashierData: any;
  /** Cashier Form. */
  allocateCashForm: FormGroup;

  selectedTeller: any;

  /** Handle transaction approval */
  approvalDialogRef: Observable<any>;
  approvalData = {};

  /**
   * Get cashier data from `Resolver`.
   * @param {FormBuilder} formBuilder Form Builder.
   * @param {ActivatedRoute} route ActivateRoute.
   * @param {Dates} dateUtils Date Utils.
   * @param {VaultTransactionsService} Vault Transactions Service.
   * @param {SettingsService} settingsService Settings Service.
   * @param {Router} router Router.
   */
  constructor(private formBuilder: FormBuilder,
              private route: ActivatedRoute,
              private dateUtils: Dates,
              private settingsService: SettingsService,
              private vaultTransactionsService: VaultTransactionsService,
              private router: Router,
              private matDialog: MatDialog,
              private tellerGlobalService: TellerGlobalServiceService,
              private receiptService: ReceiptServiceService,
              private dialogHelper: DialogHelper) {


    this.route.data.subscribe((data: { cashierTemplate: any}) => {
        this.cashierData = data.cashierTemplate;
    });

  }

  ngOnInit() {
    this.setCashierForm();
    this.tellerGlobalService.getSelectedTeller$().subscribe(data => this.selectedTeller = data);
  }

  /**
   * Set Cashier form.
   */
  setCashierForm() {
    this.allocateCashForm = this.formBuilder.group({
      'office': [{value: this.cashierData.officeName, disabled: true}],
      'tellerName': [{value: this.cashierData.tellerName, disabled: true}],
      'cashier': [{value: this.cashierData.cashierName, disabled: true}],
      'assignmentPeriod': [{value: this.dateUtils.formatDate(this.cashierData.startDate, 'dd MMMM yyyy') + ' - ' + this.dateUtils.formatDate(this.cashierData.endDate, 'dd MMMM yyyy'), disabled: true}],
      'txnDate': [new Date(), Validators.required],
      'currencyCode': ['', Validators.required],
      'txnAmount': ['', [Validators.required, Validators.min(0.01)]],
      'txnNote': ['', Validators.required]
    });
  }

  /**
   * Submits Allocate Cash form.
   */
  submit() {
    const allocateCashFormData = this.allocateCashForm.value;
    const locale = this.settingsService.language.code;
    const dateFormat = this.settingsService.dateFormat;
    const prevTxnDate = this.allocateCashForm.value.txnDate;
    allocateCashFormData.txnDate = this.dateUtils.formatDate(prevTxnDate, dateFormat);

    const data = {
      ...allocateCashFormData,
      dateFormat,
      locale,
      ...this.approvalData
    };

    this.approvalData = {};
    this.vaultTransactionsService.allocateCash(this.cashierData.tellerId, this.cashierData.cashierId, data).subscribe((res: any) => {
      if(res.hasOwnProperty('httpStatusCode') && res.httpStatusCode === '202' && res.userMessageGlobalisationCode == 'response.msg.approval.required')
      {                    
          const amount = allocateCashFormData.txnAmount;
          const currencyCode = allocateCashFormData.currencyCode;
          const otpRequestData: OTPRequestData = {
              requestAmount:  amount,
              entityId: this.selectedTeller['id'],
              title: `Recibir de bóveda  ${amount} ${currencyCode}`
          }
          
          this.approvalDialogRef = this.dialogHelper.showApprovalDialog(otpRequestData,this.matDialog).afterClosed();
          this.approvalDialogRef.subscribe(result => {
            if(result && result.hasOwnProperty('approvalToken')){
                this.approvalData = result;
                this.submit();
            }
          });
      }else{
      this.receiptService.getTellerReport(this.selectedTeller['id'],'Caja_vault',res['subResourceId']).subscribe(data =>
        this.dialogHelper.showDialog(data,this.matDialog,this.router,this.route));
      }
    });
  }

}
